import React, { useEffect, useMemo } from "react";
import { useAppFormContext } from "../rhf/FormProvider";
import { useFieldArray } from "react-hook-form";
import { Divider } from "@mui/material";
import { PlusOutlined } from "@ant-design/icons";
import { StyledButton } from "customStyled";
import { FilterInputs } from "./utils/FilterInputs";
import { FieldPath } from "../rhf/FieldPath";
import {
  buildPocDefaults,
  buildPocRules,
  pocDataToValues,
} from "../utils/addPocControl";
import { PocAccordion } from "./CommonControl";
import { useTranslation } from "react-i18next";

const keyName = "other";

/** List of "Other" Points of Contact (react-hook-form). */
const AddOtherPOC = ({ pocs, limit = 6 }) => {
  const { t } = useTranslation("form");
  const form = useAppFormContext();
  const arr = useMemo(() => ["role", "first_name_prefix", "last_name", "phone"], []);
  const { fields, append } = useFieldArray({ name: keyName });

  const addPOCControl = () =>
    append(buildPocDefaults(keyName, arr), { shouldFocus: false });

  useEffect(() => {
    form.setRules(buildPocRules(`${keyName}.*`, keyName, false, arr));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Saved "other" POCs are appended, and an empty POC is added when there is
  // no POC data (same behaviour as the previous react-reactive-form version)
  useEffect(() => {
    if (!!pocs && pocs.length) {
      pocs
        .filter((el) => el.type === keyName)
        .forEach((poc) =>
          append(pocDataToValues(buildPocDefaults(keyName, arr), poc, "phone"), {
            shouldFocus: false,
          }),
        );
    } else {
      addPOCControl();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pocs]);

  return (
    <React.Fragment>
      {fields.map((field, index) => (
        <div key={field.id} id={keyName + index}>
          <Divider />
          <FieldPath name={`${keyName}.${index}`}>
            <PocAccordion
              id="other-content"
              path={`${keyName}.${index}`}
              role={keyName}
              status={false}
              arr={arr}
              title={t("other")}
              required={false}
            >
              {arr.map((el, i) => (
                <FilterInputs status={el} key={i} />
              ))}
            </PocAccordion>
          </FieldPath>
        </div>
      ))}
      {fields.length < limit ? (
        <StyledButton
          onClick={addPOCControl}
          startIcon={<PlusOutlined fontSize="inherit" />}
          sx={{ width: "fit-content", fontWeight: 600 }}
        >
          {t("addPoc")}
        </StyledButton>
      ) : null}
    </React.Fragment>
  );
};

export default AddOtherPOC;
